import React from "react";

function FooterConfig(props) {
  return (
    <div className="wrapper__footer container p-0">
      <img src={process.env.PUBLIC_URL + "/images/imgFooter.png"} alt="" />
    </div>
  );
}

export default FooterConfig;
